import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import CollectionSearchModal from './CollectionSearch';

export type CollectionSelectedType = {
  colid?: number;
  colreference?: string;
  collabel?: string;
};

export type CollectionSelectProps = {
  onChange?: any;
  value?: CollectionSelectedType|any;
  phase?: string;
  onlyColid?: boolean;
  tpid?:number
};

const CollectionSelect = ({
  onChange = noop,
  value,
  phase,
  onlyColid,
  tpid
}: CollectionSelectProps) => {
  const [Params, setParams] = useState<CollectionSelectedType>({
    colid: value?.colid,
    colreference: value?.colreference,
    collabel: value?.collabel,
  });
  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyColid ? onChange(item.colid) : onChange(item);

    setParams({
      colreference: item?.colreference,
      collabel: item.collabel,
      colid: item?.colid,
    });
    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={() => {
          open();
          localStorage.removeItem('searchParams');
          localStorage.removeItem('searchParams_components');
        }}
        value={
          <Typography.Link>
            {!value?.colid
              ? Params?.colid && value !== 0 && value !== '' && !isNil(value)
                ? `${Params.colreference ?? ''}  -  ${Params.collabel ?? ''}`
                : 'Select Collection'
              : value?.colid && value !== 0 && value !== '' && !isNil(value)
              ? `${value.colreference ?? ''}  -  ${value.collabel ?? ''}`
              : 'Select Collection'}
          </Typography.Link>
        }
      />
      <CollectionSearchModal
        setCollection={handleSelect}
        visible={visible}
        onCancel={close}
        tpid={tpid}
      />
    </>
  );
};

export default CollectionSelect;
